import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.adminsidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-adminsidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.adminsidebar/view.scss */
/* src/app/component.adminsidebar/view.scss: no such file or directory */`],
})
export class ComponentAdminsidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public currentPath: string = '';

    public total = '';
    public answerTime = '';
    public avgResponse = '';
    public totalVisits = '';
    public uniqueVisits = '';
    public loaded: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.currentPath = location.pathname;
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("load");
        if (code !== 200) return alert("ERROR: 오류 발생. 시스템 관리자에게 문의하세요.")
        this.total = Number(data.total_questions).toLocaleString("ko-KR");
        this.answerTime = data.answer_rate;
        this.avgResponse = data.avg_ttft;
        this.totalVisits = Number(data.total_visits).toLocaleString("ko-KR");
        this.uniqueVisits = Number(data.unique_visits).toLocaleString("ko-KR");
        this.loaded = true;
        await this.service.render();
    }

    public isActive(path: string): boolean {
        return location.pathname === path;
    }
}

export default ComponentAdminsidebarComponent;